



























































import Vue from 'vue';
import * as attributoApi from '../../services/attributo-api';
import { AttributoEditViewModel } from '../../types';
import validationRulesMixin from '../../components/mixin/validation-rules-mixin';

export default Vue.extend({
    mixins: [validationRulesMixin],

    components: {},
    props: {
        fullSize: { default: false },
        tipo: { type: String },
        id: { default: 0 },
    },
    data(): AttributoEditViewModel {
        return {
            item: null,
            isValid: false,
        };
    },
    computed: {
        isNew(): boolean {
            return this.item != null && this.item.id === 0;
        },
        getTipo(): string {
            return this.tipo ?? (this.item != null ? this.item.tipo : null);
        },
    },
    methods: {
        async loadData(id: number): Promise<void> {
            if (id > 0) {
                this.item = await attributoApi.getByKey(id);
            } else {
                this.setNewItem();
            }
        },
        close() {
            this.$emit('close', this.getTipo);
        },
        setNewItem() {
            this.item = {
                id: 0,
                version: 0,
                valore: '',
                descrizione: '',
                tipo: this.getTipo,
                displayName: this.$i18n.t('labels.nuovo').toString(),
            };
        },
        async save() {
            if (!this.item) {
                return;
            }
            let response = null;
            if (this.isNew) {
                response = await attributoApi.create(this.item);
            } else {
                response = await attributoApi.update(this.item);
            }
            await this.loadData(response.id);
            this.$emit('save', this.item);
        },
    },
    async mounted() {
        await this.loadData(this.id);
        setTimeout(() => {
            this.isValid = (this.$refs.form as HTMLFormElement).validate();
        });
    },
});
